<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>購読一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'CreateSubscription' }"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="顧客"
          dense
          v-model="params.search"
          @change="getSubscriptions"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="ステータス"
          dense
          :items="$store.getters.subscriptionStatus"
          item-text="name"
          item-value="id"
          v-model="params.status"
          @change="getSubscriptions"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読開始日（FROM）"
              readonly
              dense
              v-on="on"
              v-model="params.startdate__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            @change="getSubscriptions"
            v-model="params.startdate__gte"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読開始日（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.startdate__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            @change="getSubscriptions"
            v-model="params.startdate__lte"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読終了日（FROM）"
              readonly
              dense
              v-on="on"
              v-model="params.enddate__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            @change="getSubscriptions"
            v-model="params.enddate__gte"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読終了日（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.enddate__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            @change="getSubscriptions"
            v-model="params.enddate__lte"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-select
          label="商品カテゴリ"
          :items=$store.getters.productCategories
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product__productcategory"
          @change="getSubscriptions"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品"
          :items="search_products"
          item-text="name"
          item-value="id"
          dense
          v-model="params.productdetail__product"
          @change="getSubscriptions"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="商品明細"
          dense
          :items="search_productdetails"
          item-text="name"
          item-value="id"
          v-model="params.productdetail"
          @change="getSubscriptions"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="請求方法"
          :items=$store.getters.billingMethods
          item-text="name"
          item-value="id"
          dense
          v-model="params.billingmethod"
          @change="getSubscriptions"
        >
        </v-select>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="削除データも表示"
          v-model="contain_deleted"
          dense
          @change="getSubscriptions"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          cols="4"
      >
        <v-btn
          class="title-btn mr-4 red white--text"
          @click="confirmCreateInvoiceList"
        >
          請求書一括作成
        </v-btn>
        <v-dialog v-model="invoice_dialog" persistent>
          <v-card>
            <v-card-title>
              請求書一括作成
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*請求日"
                          readonly
                          v-on="on"
                          v-model="invoice_date_of_issue"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        @input="fromDateMenu = false"
                        v-model="invoice_date_of_issue"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="createInvoiceList"
                    class="white--text red"
                    >作成する</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="invoice_dialog = false"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="invoice_alert_dialog" persistent>
          <v-card>
            <v-card-title>
              請求書一括作成
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  商品および購読終了日のFROM、TOを設定しないと請求書一括作成はできません
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    sm="12"
                  >
                  <v-btn
                    @click="invoice_alert_dialog = false"
                    color="default">閉じる</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col
          cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="data_download"
        >
          データダウンロード
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getSubscriptions"
        >
        <template v-slot:item.web_accounts="{ item }">
          <v-btn
            small
            outlined
            color="default"
            :to="{ name: 'WebAccountListSubscription', params: {subscription_id: item.id}}"
            v-if="item.webaccount_max_count"
          >
            {{ item.webaccount_count }}/{{ item.webaccount_max_count }}
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditSubscription', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
            v-if="!item.is_deleted"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="購読情報削除"
          message="購読情報を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteSubscription"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      items: [],
      params: {
        search: '',
        status: '',
        startdate__lte: '',
        startdate__gte: '',
        enddate__lte: '',
        enddate__gte: '',
        productdetail__product__productcategory: '',
        productdetail__product: '',
        productdetail: '',
        billingmethod: '',
        search_products: [],
        search_productdetals: [],
        is_deleted: false,
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      search_products: [],
      search_productdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      headers: [
        {text: "購読コード", value: "cd"},
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "list_display_name"},
        {text: "電話番号", value: "client.tel"},
        {text: "商品", value: "productdetail.name"},
        {text: "部数", value: "sum_amount"},
        {text: "ステータス", value: "status.name"},
        {text: `WEBアカウント`, value: "web_accounts"},
        {text: "操作", value: "action", width: "130px"},
      ],
      deleteItem: {},
      invoice_dialog: false,
      create_invoice_list: false,
      invoice_alert_dialog: false,
      invoice_date_of_issue: null,
      contain_deleted: false,
    };
  },
  watch: {
    'params.productdetail__product__productcategory': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
            {
              params: {'productcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_products = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_products = []
      }
    },
    'params.productdetail__product': async function(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.search_productdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.search_productdetails = [];
      }
    },
    contain_deleted: function() {
      if (this.contain_deleted) {
        this.params.is_deleted = null;
      } else {
        this.params.is_deleted = false;
      }
    }
  },
  methods: {
    async getSubscriptions() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteSubscription() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getSubscriptions();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    },
    confirmCreateInvoiceList() {
      console.log(this.params.enddate__gte, this.params.enddate__lte, this.params.productdetail__product)
      if (this.params.enddate__gte && this.params.enddate__lte && this.params.productdetail__product) {
        this.invoice_dialog = true;
      } else {
        this.invoice_alert_dialog = true;
      }
    },
    async createInvoiceList() {
      if (this.create_invoice_list) {
        return
      }
      this.create_invoice_list = true;
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/bulk_invoice/`,
          {date_of_issue: this.invoice_date_of_issue, ...this.params},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "作成されました", type: "success"});
        this.invoice_dialog = false;
        this.$router.push({'name': 'Dashboard'});
      } catch(error) {
        this.create_invoice_list = false;
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "作成できませんでした", type: "error"});
      }
    },
    async data_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/list_download/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "subscription_list.xlsx");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>
<style scoped>
.v-data-table {
  white-space : pre-wrap;
}
</style>